import {collection, component, dateField, EntityData, field, identifier, LocalisableEntityData} from "@fedeltapointofsale/data-client";
import {AddressData} from "../address/address.data";
import {AccountReferenceData} from "../accounts/account/account-reference.data";

export class ContactAccountPinData extends EntityData<ContactAccountPinData> {
    @identifier accountPinId: number;
    @field pin: string;
    @field defaultContact: boolean;
    @field invoiceContact: boolean;
    @field statementContact: boolean;
    @component account: AccountReferenceData;
}

export class ContactData extends LocalisableEntityData<ContactData> {
    @identifier id: string;
    @field integratedLoyaltyId: string;
    @field title: string;
    @field firstName: string;
    @field lastName: string;
    @field workPhone: string;
    @field homePhone: string;
    @field mobilePhone: string;
    @field fax: string;
    @field email: string;
    @dateField dob: Date;
    @field gender: number;
    @field outletGroupId: number;
    @field optedOutCommunications: boolean;
    @field deliveryContact: boolean;
    @field hourlyRate: number;
    @field deliveryInstructions: string;
    @field customerNotes: string;
    @field sendSmsOnTakeawayReady: boolean;
    @component homeAddress: AddressData;
    @component postalAddress: AddressData;
    @collection(ContactAccountPinData) accountPins: ContactAccountPinData[];

    get fullName(): string {
        return ((this.firstName || "") + " " + (this.lastName || "")).trim();
    }
}

export class ContactReferenceData extends LocalisableEntityData<ContactReferenceData> {
    @identifier id: string;
    @field title: string;
    @field firstName: string;
    @field lastName: string;

    get fullName(): string {
        return this.firstName + " " + this.lastName;
    }
}
